import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, local } from "@/lib/api";
import { logError } from "@/lib/log";

async function migrateLegacy() {
  const legacy = local.get("journal_entries", []);
  if (!legacy.length) return;
  await Promise.all(legacy.map((e) => api.post("/journal", e).catch((err) => logError("Journal migration failed:", err))));
  localStorage.removeItem("journal_entries");
}

export function useJournalEntries() {
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    migrateLegacy()
      .then(() => api.get("/journal"))
      .then(({ data }) => setEntries(data))
      .catch((e) => toast.error(errMsg(e, "Could not load your journal")));
  }, []);

  const add = useCallback(async (entry) => {
    const { data } = await api.post("/journal", entry);
    setEntries((list) => [data, ...list]);
  }, []);

  const remove = useCallback(async (id) => {
    try {
      await api.delete(`/journal/${id}`);
      setEntries((list) => list.filter((e) => e.id !== id));
    } catch (e) {
      toast.error(errMsg(e));
    }
  }, []);

  return { entries, add, remove };
}
